import React, { useEffect } from "react";
import { usePageLoading } from "hooks/usePageLoading";

const Logout = (props) => {
  const doneLoading = usePageLoading(props);
  React.useEffect(() => {
    document.body.classList.add("login-page");
    // document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    localStorage.removeItem("token");
    doneLoading(); // no hay datos que traer
    window.location = "/";
    return function cleanup() {
      document.body.classList.remove("login-page");
      // document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  return <></>;
};

export default Logout;
